import React from 'react';

export default () => (
  <svg
    width='351'
    height='137'
    viewBox='0 0 351 137'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M0 110.84H63.4027V134.093H90.1053V110.84H106.488V88.4267H90.1053V1.80859H55.1468L0 88.8142V110.84ZM63.9187 88.4267H28.1216V87.3932L62.8867 32.2961H63.9187V88.4267Z'
      fill='#D7DBEC'
    />
    <path
      d='M175.073 137C208.29 137 228.349 111.68 228.413 68.0802C228.478 24.8034 208.161 0 175.073 0C141.92 0 121.796 24.7388 121.732 68.0802C121.603 111.551 141.791 136.935 175.073 137ZM175.073 113.811C159.915 113.811 150.112 98.5677 150.176 68.0802C150.241 38.0448 159.98 22.9302 175.073 22.9302C190.101 22.9302 199.905 38.0448 199.905 68.0802C199.969 98.5677 190.165 113.811 175.073 113.811Z'
      fill='#D7DBEC'
    />
    <path
      d='M244.512 110.84H307.915V134.093H334.617V110.84H351V88.4267H334.617V1.80859H299.659L244.512 88.8142V110.84ZM308.431 88.4267H272.633V87.3932L307.399 32.2961H308.431V88.4267Z'
      fill='#D7DBEC'
    />
  </svg>
);
